const commentAudit = () => import('@/pages/product/commentAudit/index.vue');

export default [{
    path: '/product/commentAudit',
    component: commentAudit,
    meta: [{
        name: '产品管理',
		activeRoute: '/product/manage'
    },
    {
        name: '评论审核',
        activeRoute: '/product/commentAudit'
    }]
}];